"use client"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Image from "next/image"
import Link from "next/link"
import { Desktop, Mobile } from "ui"

function scrollToLeadForm() {
  if (typeof window === "undefined") return
  const el = document.getElementById("lead-form")
  if (el) {
    try {
      el.scrollIntoView({ behavior: "smooth", block: "start" })
    } catch (e) {
      // Fallback
      const top = el.getBoundingClientRect().top + window.scrollY
      window.scrollTo({ top, behavior: "smooth" })
    }
  }
}

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  ${(props) => props.theme.breakpoints.down("md")} {
    padding-bottom: 0;
  }
`
const Title = styled(Typography)`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const PreTitle = styled.span`
  position: relative;
  font-weight: 400;
  /* Min 32px → Max 53px */
  font-size: clamp(32px, 3vw, 53px);
  line-height: 1.05;
  text-align: center;
  padding: 0;
  unicode-bidi: plaintext;
`
// const StyledDiscount = styled.div<{ $yOffset: string }>`
//   /* CSS custom properties for cross-platform positioning adjustments */
//   --label-offset-x: 5.1em; /* horizontal offset from center */
//   --label-offset-y: ${(props) => props.$yOffset}; /* dynamic vertical offset based on platform */

//   display: block;
//   position: relative;
//   font-weight: 800;
//   /* Min 84px (mobile) → fluid via vw → Max 144px (1920px design) */
//   font-size: clamp(84px, 9vw, 144px);
//   line-height: 1; /* explicit to prevent platform variance */
//   letter-spacing: -0.04em;
//   text-align: center;
//   color: #1988e2;
//   background-color: #ffe600;
//   padding: 0 0.2em;
//   border-radius: 0.05em;
//   font-family: inherit; /* ensure consistent font stack */

//   span {
//     font-weight: 600;
//     font-size: 0.25em;
//     letter-spacing: 0;
//     line-height: 1;
//   }
// `
// const StyledPreDiscount = styled.div`
//   position: absolute;
//   /* Center vertically and horizontally, then adjust with custom properties */
//   top: 50%;
//   right: 50%;
//   transform: translate(calc(-50% + var(--label-offset-x)), calc(-50% + var(--label-offset-y)));

//   background-color: #ffe600;
//   color: #1988e2;
//   font-size: 0.23em; /* relative to parent font-size for proportional scaling */
//   line-height: 1; /* explicit for consistency */
//   font-weight: 500;
//   letter-spacing: 0;
//   padding: 0.15em 0.5em;
//   border-radius: 0.25em;
//   white-space: nowrap;
//   pointer-events: none;
//   font-family: inherit;
// `

const StyledDiscountImage = styled(Image)`
  width: 37vw;
  width: clamp(380px, 38vw, 630px);
  height: 14.5vw;
  height: clamp(170px, 16.5vw, 270px);
  margin: -3vw 0;
  margin: clamp(-60px, -3.5vw, -35px);
`

const StyledInnerTitle = styled.span`
  font-weight: 800;
  /* Min 33px → Max 54px */
  font-size: clamp(33px, 3.33vw, 54px);
  line-height: 1;
  text-align: center;
  unicode-bidi: plaintext;
  letter-spacing: 0.04em;
  margin-top: 0.2em;
`

const StyledSubtitle = styled(Typography)`
  /* Min 24px → Max 39px */
  font-size: clamp(24px, 2.2vw, 39px);
  line-height: 0.965;
  text-align: center;
  padding: 0.3em 0 0.5em;
  unicode-bidi: plaintext;
  max-width: 15em;
`

// Button sizing based on current font size context (use em units)
const UpgradeButton = styled.button`
  font-family: inherit;
  font-weight: 700;
  /* Button text scales: Min 20px → Max 36px */
  font-size: clamp(20px, 1.875vw, 36px);
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.4em 0.8em; /* scales with font-size */
  background: #ffffff;
  color: #1988e2;
  border: none;
  border-radius: 0.3em;
  cursor: pointer;
  box-shadow: none;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  position: relative;
  unicode-bidi: plaintext;
  &:hover {
    background: #f5f7fa;
  }
  &:active {
    transform: translateY(2px);
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.12);
  }
  &:focus-visible {
    outline: 2px solid #1988e2;
    outline-offset: 2px;
  }
`

const MobileButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
  margin-bottom: -25px;
  direction: ltr;
`

const YellowMobileButton = styled(UpgradeButton)`
  background: #ffe600;
  color: #1988e2;
  &:hover,
  &:focus-visible {
    background: #f5f7fa;
  }
  width: 148px;
  height: 38px;
  border-radius: 0;
  margin: 0;
  font-size: 19px;
  font-weight: 400;
  gap: 5px;
  white-space: nowrap;
  text-decoration: none !important;
`

// const Arrow = styled.span`
//   display: inline-block;
//   font-weight: 400;
//   line-height: 1;
//   margin-right: 0.6em; /* space between arrow and text (arrow on left visually) */
//   font-size: 0.9em; /* slightly smaller than text */
// `

export default function HeroContent() {
  // const [yOffset, setYOffset] = useState("-0.25em") // default offset for most devices

  // useEffect(() => {
  //   const detectPlatform = () => {
  //     const userAgent = navigator.userAgent.toLowerCase()
  //     const platform = navigator.platform.toLowerCase()

  //     // Detect Mac (desktop)
  //     if (platform.includes("mac") || userAgent.includes("macintosh")) {
  //       setYOffset("0em") // no offset for Mac
  //     }
  //     // Detect iOS (iPhone, iPad)
  //     else if (
  //       userAgent.includes("iphone") ||
  //       userAgent.includes("ipad") ||
  //       userAgent.includes("ipod")
  //     ) {
  //       setYOffset("0em") // no offset for iOS
  //     }
  //     // All other devices (Windows, Android, Linux, etc.) - apply offset
  //     else {
  //       setYOffset("-0.25em")
  //     }
  //   }

  //   detectPlatform()
  // }, [])
  return (
    <StyledLayout>
      <Mobile>
        <Image
          src="/landingpages/homeupgrades/main-logo.svg"
          alt="אשטרום מגורים"
          width={122}
          height={70}
          priority
          style={{ marginBottom: "60px" }}
        />
      </Mobile>
      <Title variant="h1">
        <PreTitle>רוכשים דירה ומקבלים</PreTitle>
        {/* <StyledDiscount $yOffset={yOffset}>
          <StyledPreDiscount>עד</StyledPreDiscount>
          <span> ₪ </span>400,000
        </StyledDiscount> */}
        <StyledDiscountImage
          src="/landingpages/homeupgrades/Flah.svg"
          alt={`עד 400,000 ש"ח`}
          width="518"
          height="144"
          priority
        />
        <StyledInnerTitle>לשינויים בדירה במתנה!</StyledInnerTitle>
      </Title>
      <StyledSubtitle>כדי שזו תהיה בדיוק הדירה שרציתם מא&apos; ועדדדדדדדדדדדדדד...</StyledSubtitle>
      <Desktop>
        <UpgradeButton aria-label="שדרגו" type="button" onClick={scrollToLeadForm}>
          תשדרגו לי &gt;
        </UpgradeButton>
      </Desktop>
      <Mobile>
        <MobileButtonsWrapper>
          <Link href="tel:0772307388" aria-label="לשיחה עם נציג" passHref legacyBehavior>
            <YellowMobileButton as="a">
              לשיחה עם נציג
              <Image
                src="/landingpages/homeupgrades/call-phone.svg"
                alt="טלפון"
                width={16}
                height={16}
              />
            </YellowMobileButton>
          </Link>

          <YellowMobileButton onClick={scrollToLeadForm}>לתיאום פגישה</YellowMobileButton>
        </MobileButtonsWrapper>
      </Mobile>
    </StyledLayout>
  )
}
